import FetchClientUserTokenQueryHandler
  from '@/application/clientUser/fetchClientUserToken/FetchClientUserTokenQueryHandler';
import ClientUserTokenRepositoryApi from '@/infrastructure/clientUser/ClientUserTokenRepositoryApi';

export default {};

export const fetchClientUserToken = new FetchClientUserTokenQueryHandler(
  new ClientUserTokenRepositoryApi(),
);
